"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_guid_1 = require("dyna-guid");
var consoleStringify_1 = require("../utils/consoleStringify");
var defaultSettings_1 = require("../defaultSettings");
var DynaNodeMessage = /** @class */ (function () {
    function DynaNodeMessage() {
        this.id = dyna_guid_1.guid();
        this.headers = {};
        this.dynaNodeInfo = {
            created: new Date,
        };
        this.traces = [];
    }
    Object.defineProperty(DynaNodeMessage.prototype, "data", {
        get: function () {
            if (this._serializedData) {
                try {
                    this._data = JSON.parse(this._serializedData);
                }
                catch (error) {
                    console.error('DynaNodeMessage, cannot unpack data', consoleStringify_1.consoleStringify({ message: this.viewSecure, error: error, serializedData: this._serializedData }));
                }
                this._serializedData = undefined;
            }
            return this._data;
        },
        set: function (data) {
            this._data = data;
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeMessage.prototype.reply = function (replyArgs) {
        var ra = __assign({ args: undefined, data: undefined, updateReplyOf: true, updateReplyOfArgs: false, updateReplyOfData: false }, replyArgs);
        var replyMessage = new DynaNodeMessage();
        replyMessage.from = this.to; // this is for internal messages replies, the server overwrites always the fromm (security topic)
        replyMessage.to = this.from;
        replyMessage.command = ra.command;
        replyMessage.args = ra.args;
        replyMessage.data = ra.data;
        replyMessage.headers = ra.headers || {};
        if (this.headers.dynaNodeTrace)
            replyMessage.headers.dynaNodeTrace = true; // Propagate the dynaNodeTrace on replied message
        replyMessage.traces = this.traces.concat();
        replyMessage._addTrace('DynaNode/Message/REPLY_MESSAGE', 'DynaNode: REPLY');
        if (ra.updateReplyOf) {
            replyMessage.replyOf = {
                id: this.id,
                from: this.from,
                to: this.to,
                command: this.command,
                args: ra.updateReplyOfArgs ? this.args : undefined,
                data: ra.updateReplyOfData ? this.data : undefined,
                binaryData: ra.updateReplyOfData ? this.binaryData : undefined,
                replyOf: ra.updateReplyOfReplyOf ? this.replyOf : undefined,
                traces: this.traces.concat(),
            };
        }
        return replyMessage;
    };
    Object.defineProperty(DynaNodeMessage.prototype, "_internal_9293", {
        set: function (id) {
            this.id = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeMessage.prototype, "_internal_9294", {
        get: function () {
            return this._serializedData;
        },
        set: function (serializedData) {
            this._serializedData = serializedData;
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeMessage.prototype.pack = function () {
        var _a = this.headers.dynaMaxPacketSizeProtection, dynaMaxPacketSizeProtection = _a === void 0 ? defaultSettings_1.DEFAULT_maxMessagePacketSize : _a;
        var packet = this.binaryData
            ? packBinaryMessage(this)
            : packRegularMessage(this);
        var validPacketSize = !this.headers.dynaMaxPacketSizeProtection || packet.length <= dynaMaxPacketSizeProtection;
        return {
            packet: packet,
            packetSize: packet.length,
            validPacketSize: validPacketSize,
        };
    };
    DynaNodeMessage.prototype.unPack = function (packedMessage) {
        if (typeof packedMessage === 'string')
            return unpackRegularMessage(packedMessage, this);
        else
            return unpackBinaryMessage(packedMessage, this);
    };
    Object.defineProperty(DynaNodeMessage.prototype, "viewSecure", {
        get: function () {
            var _this = this;
            var secureFields = [
                'headers',
                'args',
                this.command.indexOf('error/dyna-node/') === 0 && 'data',
            ].filter(Boolean);
            return [
                'id',
                'headers',
                'from',
                'to',
                'command',
                'args',
                'data',
                'binaryData',
                'replyOf',
                'traces',
                'dynaNodeInfo',
            ].reduce(function (acc, property) {
                var value = _this[property];
                if (value !== undefined) {
                    acc[property] =
                        secureFields.includes(property)
                            ? '---hidden for security reasons---'
                            : value;
                }
                return acc;
            }, {});
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeMessage.prototype, "viewFull", {
        get: function () {
            var _this = this;
            return [
                'id',
                'headers',
                'from',
                'to',
                'command',
                'args',
                'data',
                'binaryData',
                'replyOf',
                'traces',
                'dynaNodeInfo',
            ].reduce(function (acc, property) {
                var value = _this[property];
                if (value !== undefined)
                    acc[property] = value;
                return acc;
            }, {});
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeMessage.prototype, "packetSize", {
        // The size of the message when is packet. This is greedy do not use it in production!
        get: function () {
            return this.pack().packet.length;
        },
        enumerable: true,
        configurable: true
    });
    // This is for end user, enables the the traces and adds a trace
    DynaNodeMessage.prototype.addTrace = function (section, desc, data) {
        if (!this.headers.dynaNodeTrace) {
            this.headers.dynaNodeTrace = true;
            this.addTrace('DYNA_NODE/TRACE/ENABLE', 'Traces enabled by addTrace()');
        }
        this._addTrace(section, desc, data);
    };
    // This is for internal DynaNode use, adds the traces only when are enabled
    DynaNodeMessage.prototype._addTrace = function (section, desc, data) {
        var _this = this;
        if (!this.headers.dynaNodeTrace)
            return false;
        var now = new Date;
        this.traces.push({
            section: section,
            command: this.command,
            date: now.valueOf(),
            dateText: now.toLocaleString(),
            afterMs: (function () {
                var last = _this.traces[_this.traces.length - 1];
                if (!last)
                    return 0;
                return now.valueOf() - last.date;
            })(),
            from: this.from,
            to: this.to,
            desc: desc,
            traceData: data,
        });
        return true;
    };
    DynaNodeMessage.prototype.addTracesIfEnabled = function (addTraces) {
        if (!addTraces)
            return;
        if (!this.headers.dynaNodeTrace && !this.traces.length)
            return; // Exit, traces are not enabled
        var copyFromMessage = addTraces.copyFromMessage, addTrace = addTraces.addTrace;
        if (copyFromMessage)
            this.traces = this.traces.concat(copyFromMessage.traces);
        if (addTrace)
            this._addTrace(addTrace.section, addTrace.desc, addTrace.data);
    };
    return DynaNodeMessage;
}());
exports.DynaNodeMessage = DynaNodeMessage;
// private
function packRegularMessage(message) {
    var header = JSON.stringify({
        id: message.id,
        from: message.from,
        to: message.to,
        command: message.command,
        args: message.args,
        headers: message.headers,
        replyOf: message.replyOf,
        dynaNodeInfo: message.dynaNodeInfo,
        traces: message.traces,
    });
    var data = message._internal_9294 || JSON.stringify(message.data);
    return header.length + "#" + header + data;
}
function packBinaryMessage(message) {
    var messageBodyData = packRegularMessage(message);
    var messageBodyDataBuffer = Buffer.from(messageBodyData);
    var messageBodySize = String(messageBodyDataBuffer.length);
    while (messageBodySize.length < 10)
        messageBodySize += ' ';
    var messageBodySizeBuffer = Buffer.from(messageBodySize);
    var binaryData = message.binaryData;
    return Buffer.concat([messageBodySizeBuffer, messageBodyDataBuffer, binaryData], messageBodySizeBuffer.length + messageBodyDataBuffer.length + binaryData.length);
}
function unpackRegularMessage(packedMessage, message) {
    try {
        var packHeaderSplitter = packedMessage.indexOf("#");
        var packHeaderLength = Number(packedMessage.substr(0, packHeaderSplitter));
        var packHeader = JSON.parse(packedMessage.substr(packHeaderSplitter + 1, packHeaderLength));
        var serializedData = packedMessage.substr(packHeaderSplitter + 1 + packHeaderLength);
        message._internal_9293 = packHeader.id;
        message.from = packHeader.from;
        message.to = packHeader.to;
        message.command = packHeader.command;
        message.args = packHeader.args;
        message.headers = packHeader.headers;
        message.data = null;
        message._internal_9294 = serializedData === 'undefined' ? undefined : serializedData;
        message.replyOf = packHeader.replyOf;
        message.dynaNodeInfo = packHeader.dynaNodeInfo || packHeader.dynaNode; // "||" for backward compatibility
        message.traces = packHeader.traces || [];
        return { success: true };
    }
    catch (error) {
        return {
            success: false,
            error: {
                section: 'DynaNodeMessage/unpackRegularMessage',
                code: 9490340965,
                message: 'Cannot unpack regular message, probably the message is corrupted',
                data: {
                    error: error,
                    message: message,
                    packedMessage: packedMessage,
                },
            },
        };
    }
}
function unpackBinaryMessage(packedMessage, message) {
    try {
        var dataBodySize = Number(Buffer.from(getFromBuffer(packedMessage, 0, 10)));
        var dataBody = (Buffer.from(getFromBuffer(packedMessage, 10, dataBodySize))).toString();
        var binaryData = Buffer.from(getFromBuffer(packedMessage, 10 + dataBodySize, packedMessage.length - (10 + dataBodySize)));
        var unpackResult = unpackRegularMessage(dataBody, message);
        if (unpackResult.error)
            return unpackResult;
        else {
            message.binaryData = binaryData;
            return { success: true };
        }
    }
    catch (error) {
        return {
            success: false,
            error: {
                section: 'DynaNodeMessage/unpackBinaryMessage',
                code: 7846290434,
                message: error.message,
                data: {
                    error: error,
                    message: message,
                    packedMessage: packedMessage,
                },
            },
        };
    }
}
var getFromBuffer = function (buffer, from, length) {
    var output = [];
    for (var i = from; i < from + length; i++)
        output.push(buffer[i]);
    return output;
};
//# sourceMappingURL=DynaNodeMessage.js.map